document.addEventListener('DOMContentLoaded', () => {
  const titles = document.querySelectorAll('.animate-title');

  // Helper function to check if an element is in the viewport
  function isInViewport(el, offset = 0.9) {
    const rect = el.getBoundingClientRect();
    return rect.top <= window.innerHeight * offset && rect.bottom >= 0;
  }

  // Function to animate a title
  function animateTitle(title) {
    const splitText = new SplitText(title, { type: 'words,chars' });
    const chars = splitText.chars;

    gsap.set(chars, { x: 50, autoAlpha: 0 });

    gsap.to(chars, {
      x: 0,
      autoAlpha: 1,
      duration: 0.6,
      stagger: 0.02,
    });
  }

  // Track which titles have already been animated
  const animatedTitles = new WeakSet();

  // Scroll handler
  function onScroll() {
    titles.forEach((title) => {
      if (!animatedTitles.has(title) && isInViewport(title, 0.9)) {
        animateTitle(title);
        animatedTitles.add(title); // Mark as animated to prevent replay
      }
    });
  }

  // Initial check in case some titles are already in view
  onScroll();

  // Listen to scroll events
  window.addEventListener('scroll', onScroll);
});
